import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { GroupSelectionDialogComponent } from './components/statistics-menu/group-selection-dialog/group-selection-dialog.component';
import { DialogService } from '@core/services/dialog.service';

@Component({
  templateUrl: './statistics-page.component.html',
  styleUrls: ['./statistics-page.component.scss', '../../styles/page.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StatisticsPageComponent {
  private dialog = inject(DialogService);

  onSelectGroupClicked(): void {
    this.dialog.open<undefined, GroupSelectionDialogComponent>({
      size: 'md',
      title: 'Statistics.SelectDepartment',
      confirmText: 'General.Apply',
      cancelText: 'General.Cancel',
      contentComponent: GroupSelectionDialogComponent,
      onConfirm: event => event.context.contentComponent?.performSave(),
    });
  }
}
